import Folder from '../store/schema/Folder';
import FolderStore from '../store/schema/FolderStore';
import { addFolderInSortedOrderUnderParentFolder } from '../actions/localFolderOperations';
import getFullFolderId from '../util/getFullFolderId';
import getFolderTable from '../selectors/getFolderTable';
import { mutator } from 'satcheljs';
import {
    onCreateNewFolderSuccess,
    onCreateNewFolderInboxRulesResponse,
} from '../actions/publicActions';
import BaseFolderType from 'owa-service/lib/contract/BaseFolderType';

mutator(onCreateNewFolderSuccess, actionMessage => {
    addFolderToStore(
        actionMessage.folderStore,
        actionMessage.folder,
        actionMessage.parentFolderId,
        actionMessage.displayName
    );
});

mutator(onCreateNewFolderInboxRulesResponse, actionMessage => {
    addFolderToStore(
        actionMessage.folderStore,
        actionMessage.folder,
        actionMessage.parentFolderId,
        actionMessage.displayName
    );
});

function addFolderToStore(
    folderStore: FolderStore,
    item: BaseFolderType,
    parentFolderId: string,
    displayName: string
) {
    const fullParentFolderId = getFullFolderId(parentFolderId);
    // Get the parent folder tree type here. This will also become the treetype of the folder currently being added.
    const parentFolderTreeType = getFolderTable().get(parentFolderId).treeType;
    const folder: Folder = {
        ...{
            DisplayName: displayName,
            ParentFolderId: fullParentFolderId,
            childFolderIds: [],
            FolderClass: 'IPF.Note',
            distinguishedFolderId: undefined,
            UnreadCount: 0,
            TotalCount: 0,
            treeType: parentFolderTreeType,
        },
        ...item,
    };

    folderStore.folderTable.set(item.FolderId.Id, folder);
    addFolderInSortedOrderUnderParentFolder(folder, folderStore, fullParentFolderId.Id);
}
